export type UploadFileType = 'image' | 'video' | 'audio' | 'file';

const IMAGE_EXTENSIONS = new Set([
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'bmp',
  'svg',
]);

const VIDEO_EXTENSIONS = new Set([
  'mp4',
  'mov',
  'webm',
  'mkv',
  'avi',
  'm4v',
  'mpeg',
  'mpg',
]);

const AUDIO_EXTENSIONS = new Set([
  'mp3',
  'wav',
  'm4a',
  'aac',
  'flac',
  'ogg',
  'oga',
  'opus',
  'wma',
]);

const getFileExtension = (nameOrUrl: string): string => {
  const withoutQuery = nameOrUrl.split(/[?#]/, 1)[0];
  const fileName = withoutQuery.split('/').pop() || '';
  return fileName.includes('.') ? fileName.split('.').pop()?.toLowerCase() || '' : '';
};

export const resolveUploadFileType = (
  file: File | string | null | undefined,
): UploadFileType => {
  if (file == null) return 'file';

  if (typeof file !== 'string') {
    const mimeType = file.type.toLowerCase();
    if (mimeType.startsWith('image/')) return 'image';
    if (mimeType.startsWith('video/')) return 'video';
    if (mimeType.startsWith('audio/')) return 'audio';
  }

  const extension = getFileExtension(typeof file === 'string' ? file : file.name);
  if (IMAGE_EXTENSIONS.has(extension)) return 'image';
  if (VIDEO_EXTENSIONS.has(extension)) return 'video';
  if (AUDIO_EXTENSIONS.has(extension)) return 'audio';
  return 'file';
};
